<template>
  <div class="fill-height">
    <v-container grid-list-xs class="d-flex justify-center">
      <div class="card-container">
        <v-container
          grid-list-xs
          class="d-flex flex-column justify-center align-center py-16"
        >
          <v-card class="card-radius card-shadow card-width" elevation="0">
            <v-card-title
              primary-title
              class="accentDarkBlue white--text title font-weight-medium px-10"
              >Buat Password Baru</v-card-title
            >

            <v-container grid-list-xs class="py-5">
              <v-form class="form px-5" ref="form" v-on:submit.prevent>
                <v-text-field
                  label="Password"
                  v-model="password"
                  :rules="passwordRules"
                  filled
                  :type="show1 ? 'text' : 'password'"
                  :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="show1 = !show1"
                  @keyup.enter.native="register"
                >
                  <template v-slot:prepend-inner>
                    <v-icon class="mx-2">mdi-lock-outline</v-icon>
                  </template>
                </v-text-field>

                <v-text-field
                  label="Konfirmasi Password"
                  v-model="confirmPassword"
                  filled
                  :rules="confirmationPasswordRules"
                  :type="show2 ? 'text' : 'password'"
                  :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="show2 = !show2"
                  @keyup.enter.native="register"
                >
                  <template v-slot:prepend-inner>
                    <v-icon class="mx-2">mdi-lock-outline</v-icon>
                  </template>
                </v-text-field>
                <center class="mt-2">
                  <p v-if="error" class="red--text caption">{{ error }}</p>

                  <v-btn
                    style="width: 100%; font-size: 1rem"
                    color="accentDarkBlue white--text py-6 mb-3"
                    @click="send"
                    >Kirim</v-btn
                  >
                </center>
              </v-form>
            </v-container>
          </v-card>
        </v-container>
      </div>
      <v-snackbar :color="color" v-model="snackbar" :timeout="timeout">
        {{ text }}

        <template v-slot:action="{ attrs }">
          <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
            Close
          </v-btn>
        </template>
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
import { EventBus } from "../event-bus";

export default {
  data: () => ({
    password: "",
    confirmPassword: "",
    token: "",
    email: "",
    error: "",
    text: "",
    timeout: 5000,
    color: "green",
    show1: false,
    show2: false,
    snackbar: false,
    passwordRules: [
      (v) => !!v || "Mohon isi password",
      (v) => (v && v.length >= 6) || "Password harus lebih dari 6 karakter",
    ],
  }),
  computed: {
    confirmationPasswordRules() {
      return [
        () =>
          this.password === this.confirmPassword ||
          "Konfirmasi password harus sama dengan password",
        (v) => !!v || "Mohon isi konfirmasi password",
      ];
    },
  },
  mounted() {
    var route = this.$route.query;
    this.token = route.token;
    this.email = route.email;

    if (this.token == undefined && this.email == undefined) {
      let hostDestination =
        window.location.hostname === "localhost"
          ? `localhost:${window.location.port}`
          : window.location.hostname;

      window.location.href = `http://${hostDestination}`;
    }
  },
  methods: {
    async send() {
      if (this.$refs.form.validate()) {
        EventBus.$emit("startLoading");

        const resEmail = await axios.post(`${this.$api}/password/reset`, {
          email: this.email,
          password: this.password,
          token: this.token,
        });

        if (resEmail.data.STATUS == "ERROR") {
          EventBus.$emit("stopLoading");
          this.error = resEmail.data.MESSAGE;
          this.text = resEmail.data.MESSAGE;
          this.color = "red";
          this.snackbar = true;
        } else {
          EventBus.$emit("stopLoading");
          this.error = "";
          this.color = "green";
          this.text = resEmail.data.MESSAGE;
          this.snackbar = true;
          setTimeout(() => {
            this.$router.push({ name: "login" });
          }, 1000);
        }

        EventBus.$emit("stopLoading");
      }
    },
  },
};
</script>

<style scoped>
.card-width {
  width: 30rem;
}

.card-container {
  width: 100%;
}

.card-shadow {
  box-shadow: -2px -2px 4px rgba(0, 0, 0, 0.08), 2px 2px 4px rgba(0, 0, 0, 0.08) !important;
}

.pink-color {
  background-color: #fec0a0;
}

.card-text {
  font-size: 1.2rem;
}

.card-radius {
  border-radius: 10px !important;
}

.icon-radius {
  border-radius: 7px !important;
}

.card-wrapper {
  margin: 100px 0;
  width: 70%;
}

.inbox-card {
  border-left: 8px solid #2a429e;
}

.a-link {
  text-decoration: none;
  color: #2a429e;
}

.a-link:hover {
  text-decoration: underline;
}

@media screen and (max-width: 600px) {
  .card-width {
    width: 100%;
  }

  .card-text {
    font-size: 1rem;
  }
}
</style>
